import format from 'date-fns/format'
import React from 'react'
import { useHistory } from 'react-router-dom'
import logo from '../../assets/images/t_logo.png'
import styles from './frontpage.module.scss'
import { releaseDetail } from '../../utils/utils'

const ResetPassword = React.lazy(() => import('./ResetPassword'))
const NewPassword = React.lazy(() => import('./NewPassword'))
const Register = React.lazy(() => import('./Register'))
const Login = React.lazy(() => import('./Login'))

interface IProps {
  type: 'login' | 'register' | 'resetPassword' | 'newPassword'
}

interface IModule {
  title: string,
  subtitle?: string
}

interface IContent {
  login: IModule,
  register: IModule,
  resetPassword: IModule,
  newPassword: IModule
}



const FrontPage: React.FunctionComponent<IProps> = ({ type }: IProps) => {
  const history = useHistory()

  const date = format(new Date(), 'yyyy')

  const DisplayModule: Record<string, React.FunctionComponent> = {
    login: Login,
    register: Register,
    resetPassword: ResetPassword,
    newPassword: NewPassword
  }

  const content: IContent = {
    login: {
      title: 'Velkommen til <br />Internetbooking<span style="color:#2bab66">.</span>',
      subtitle: 'En taxaoplevelse dine medarbejdere fortjener'
    },
    register: {
      title: 'Du er blevet inviteret til<br /> Internetbooking.',
      subtitle: 'En taxaoplevelse dine medarbejdere fortjener'
    },
    resetPassword: {
      title: 'Glemt kodeord?',
      subtitle: 'Indtast din mail, så får du et link et at lave et nyt kodeord'
    },
    newPassword: {
      title: 'Indtast nyt kodeord'
    }
  }

  const Module = DisplayModule[type]

  return (
    <div className={styles.frontPage}>
      <div className={styles.backDrop}>
        <span className={styles.logo} onClick={() => history.push('/login')}>
          <img src={logo} alt="Dantaxi logo" />
        </span>
        <main className='tw-m-auto tw-p-5'>
          <header className={styles.header}>
            <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: content[type].title }} />
            {content[type].subtitle && <p className={styles.subtitle} dangerouslySetInnerHTML={{ __html: content[type].subtitle }} />}
          </header>
          <div className={styles.container}>
            <Module />
          </div>
        </main>
        <footer className={styles.footer}>
          <span className={styles.version}>{releaseDetail.version} </span>
          <span className={styles.copyright}>	&#169; {date} Dantaxi</span>
        </footer>
      </div >
    </div>
  )
}

export default FrontPage
